<template>
  <q-page class="bg-grey-1">
    <q-icon
      name="account_circle"
      style="font-size: 100px;"
      color="indigo-6"
      class="text-center full-width q-mt-xl"
    />
    <div class="text-h6 pc-semibold text-grey-9 text-center q-mb-xl">
      {{ currentUser.email }}
    </div>
    <div class="q-pa-md">
      <q-input
        label="Name"
        rounded
        standout="bg-indigo-6 text-white"
        class="q-mb-md"
        v-model="currentUser.name"
        :readonly="!isEditActive"
      />
      <q-input
        label="Last name"
        rounded
        standout="bg-indigo-6 text-white"
        class="q-mb-md"
        v-model="currentUser.lastName"
        :readonly="!isEditActive"
      />
      <q-btn
        label="Edit"
        icon="edit"
        unelevated
        rounded
        class="full-width q-py-xs pc-semibold"
        no-caps
        color="indigo-6"
        v-if="!isEditActive"
        @click="isEditActive = !isEditActive"
      />
      <q-btn
        label="Save"
        icon="check"
        flat
        rounded
        class="full-width q-py-xs pc-semibold"
        no-caps
        color="green-6"
        v-else
        @click="saveNewUserData()"
      />
      <q-separator class="q-my-md" />
      <q-btn
        label="Delete all my passwords"
        icon="remove_circle_outline"
        unelevated
        rounded
        class="full-width q-mb-md q-py-xs pc-semibold"
        no-caps
        color="amber-6"
        @click="deleteAllUserPasswords()"
      />
      <q-btn
        label="Delete my account"
        icon="delete"
        unelevated
        outline
        rounded
        class="full-width q-py-xs pc-semibold"
        no-caps
        color="red-6"
        @click="deleteAllUserData()"
      />
      <div class="row q-mt-lg">
        <q-space />
        <router-link to="/about" style="text-decoration: none;">
          <div class="text-subtitle2 text-grey-6 pc-bold">
            About
          </div>
        </router-link>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      isEditActive: false,
    };
  },
  methods: {
    ...mapActions("appStore", [
      "updateUserData",
      "deleteAllUserPasswords",
      "deleteAllUserData",
    ]),

    saveNewUserData() {
      if (this.currentUser.name == "" || this.currentUser.lastName == "") {
        this.$q.notify({
          message: "Name and last name are required fields",
          color: "red-6",
          icon: "error",
          badgeColor: "amber-6",
          progress: true,
          classes: "pc-font pc-semibold higher-toast",
          timeout: 2000,
        });
        return;
      }
      this.isEditActive = false;
      this.updateUserData(this.currentUser);
    },
  },
  computed: {
    ...mapState("appStore", ["currentUser"]),
  },
};
</script>
